<template>
  <!-- 個人頁 -->

  <div class="content my-message">
    <p class="title">
      {{ $t("Bao.notify_letter") }}
      <button v-if="letters.length != 0" :disabled="actionLoading" @click="setAllRead">
        {{ $t("Bao.mark_all_read") }}
        <i v-show="actionLoading" class="fa fa-spinner fa-pulse fa-fw" />
      </button>
    </p>
    <div class="message-list">
      <!--沒有資料時顯示-->
      <div v-if="letters.length == 0 && !loading" class="list-content list-mobile">
        <div class="no-data">
          <i><img :src="getThemeImagePath('no-data.png')" alt=""></i>
          <p>{{ $t('Bao.no_relevant_data_records') }}</p>
          <span>{{ $t('Bao.search_results_are_empty') }}</span>
        </div>
      </div>
      <div
        v-for="message in letters"
        :key="message.id"
        class="message-item"
        :class="{ active: message.show }"
      >
        <div class="message-info" @click="toggleMessage(message.id)">
          <i v-show="message.status == 0" />  <!--未讀時顯示的綠點點-->
          <!--eslint-disable-next-line-->
          <span v-html="message.title" />
          <span>{{ message.created_at | dateFormat }}</span>
        </div>
        <div class="message-box">
          <!--eslint-disable-next-line-->
          <p v-html="message.content" />
        </div>
      </div>
    </div>
    <scroll-loader :loader-method="query" :loader-disable="!enableAutoLoad" />
  </div>
</template>

<script>
import { getLetter, setLetterRead, setAllLetterRead } from '@/api/user'
import { showNotice, getThemeImagePath } from '@/utils/tool'
import ScrollLoader from 'vue-scroll-loader/src/components/Scroll-Loader'

export default {
  components: {
    ScrollLoader
  },
  data() {
    return {
      letters: [],
      page: 1,
      pageSize: 10,
      enableAutoLoad: false,
      loading: false,
      actionLoading: false
    }
  },
  computed: {
    newLetter() {
      return this.$store.state.user.newLetter
    }

  },
  watch: {
    newLetter() {
      this.oneQuery()
      this.$store.commit('SET_NEW_LETTER', false)
    }
  },
  created() {
    if (this.$store.state.user.newLetter) {
      this.$store.commit('SET_NEW_LETTER', false)
    }
    this.oneQuery()
  },
  methods: {
    async query() {
      if (this.loading) return
      this.loading = true
      const queryObj = {
        'page': this.page,
        'page_size': this.pageSize
      }
      getLetter(queryObj).then(response => {
        this.letters = [...this.letters, ...response.data.data.list]
        for (const i in this.letters) {
          if (i === 0) this.$set(this.letters[i], 'show', true)
          else this.$set(this.letters[i], 'show', false)
        }
        if (response.data.data.list.length < this.pageSize) {
          this.enableAutoLoad = false
        } else {
          this.page += 1
          this.enableAutoLoad = true
        }
        this.loading = false
      }).catch((error) => {
        showNotice(error.response.data.msg)
      })
    },
    toggleMessage(messageId) {
      const message = this.letters.find(m => m.id === messageId)
      if (message) {
        message.show = !message.show
        if (parseInt(message.status) === 0) {
          this.setRead(message)
        }
      }
    },
    oneQuery() {
      this.page = 1
      this.letters = []
      this.query()
    },
    setRead(item) {
      setLetterRead({ id: item.id }).then(response => {
        item.status = 1
        if (response.data.data.unread_letter_num === 0) {
          this.$store.commit('SET_UNREAD_LETTER', false)
        } else {
          this.$store.commit('SET_UNREAD_LETTER', response.data.data.unread_letter_num)
        }
      }).catch((error) => {
        showNotice(error.response.data.msg)
      })
    },
    setAllRead() {
      this.actionLoading = true
      setAllLetterRead().then(response => {
        for (const i in this.letters) {
          this.letters[i].status = 1
        }
        this.$store.commit('SET_UNREAD_LETTER', false)
        showNotice(response.data.msg)
      }).catch((error) => {
        showNotice(error.response.data.msg)
      }).finally((e) => {
        this.actionLoading = false
      })
    },
    getThemeImagePath
  }
}

</script>

<style scoped>
.list-content{
    position: relative;
    padding: 0 20px;
    width:100%;
    overflow-x: auto;
    height: 200px;
}
@media (max-width: 992px){
  .list-mobile {
    display: block;
    height: 350px;
  }
}
p.title{
  padding-top: 8px;
  font-size: 24px;
  padding-bottom: 5px;
}
</style>
